import React from 'react';

import * as pages from 'pages';
import * as paths from './const';

interface RouteProps {
  path: string;
  component: React.LazyExoticComponent<React.ComponentType<any>>;
}

interface RoutesProps {
  public: RouteProps[];
  common: RouteProps[];
  MASTER_ADMIN: RouteProps[];
  SITE_ADMIN: RouteProps[];
  CONSTRUCTOR: RouteProps[];
  SUB_CONSTRUCTOR: RouteProps[];
  [key: string]: RouteProps[];
}

/** 공통으로 사용되는 대시보드 라우트 */
const commonDashboardRoutes: RouteProps[] = [
  {
    path: paths.ROUTE_CHART_DASHBOARD,
    component: pages.LazyDashboardChart
  },
  {
    path: paths.ROUTE_CHART_DASHBOARD2,
    component: pages.LazyDashboard3d
  }
];

/** 공통으로 사용되는 프로젝트/회사 관리 라우트 */
const commonManagementRoutes: RouteProps[] = [
  { path: paths.ROUTE_PJT, component: pages.LazyProjectInformationPage },
  { path: paths.ROUTE_COMPANY, component: pages.LazyCompanyPage }
];

export const routes: RoutesProps = {
  public: [{ path: paths.ROUTE_SIGN_IN, component: pages.LazySignInPage }],
  common: [
    { path: paths.ROUTE_ROOT, component: pages.LazyHomePage },
    { path: paths.ROUTE_NOTICE, component: pages.LazyNoticePage },
    {
      path: paths.ROUTE_USER_ADMINISTRATOR_MANAGEMENT,
      component: pages.LazyAdministratorManagementListsPage
    },
    {
      path: paths.ROUTE_USER_FRS_MANAGEMENT,
      component: pages.LazyFrsManagementListsPage
    },
    {
      path: paths.ROUTE_USER_WORKER_MANAGEMENT,
      component: pages.LazyWorkerManagementListsPage
    },
    {
      path: paths.ROUTE_PASSPORT_SITE_ENTRY_MANAGEMENT,
      component: pages.LazySiteEntryManagementPage
    },
    {
      path: paths.ROUTE_PASSPORT_SAFETY_TRAINING,
      component: pages.LazySafetyTrainingListsPage
    },
    {
      path: paths.ROUTE_PASSPORT_SITE_ENTRY_HISTORY,
      component: pages.LazySiteEntryHistoryPage
    },
    {
      path: paths.ROUTE_ENVIRONMENT_CURRENT,
      component: pages.LazyEnvironment
    },
    {
      path: paths.ROUTE_ENVIRONMENT_HISTORTY,
      component: pages.LazyEnvironmentHistory
    },

    // SAMSUNG 전용
    {
      path: paths.ROUTE_TBM_STATUS,
      component: pages.LazyTbmStatusPage
    },
    {
      path: paths.ROUTE_TBM_ATTENDANCE,
      component: pages.LazyTbmAttendancePage
    },
    {
      path: paths.ROUTE_TBM_MONITORING,
      component: pages.LazyTbmMonitoringPage
    }
  ],
  MASTER_ADMIN: [
    ...commonDashboardRoutes,
    ...commonManagementRoutes,
    {
      path: paths.ROUTE_USER_APPROVAL,
      component: pages.LazyUserApprovalListPage
    },
    {
      path: paths.ROUTE_PASSPORT_TRAINING_SETTING,
      component: pages.LazySafetyTrainingSettingPage
    },
    {
      path: paths.ROUTE_SYSTEM,
      component: pages.LazySystemPage
    }
  ],
  SITE_ADMIN: [
    ...commonDashboardRoutes,
    ...commonManagementRoutes,
    {
      path: paths.ROUTE_USER_APPROVAL,
      component: pages.LazyUserApprovalListPage
    },
    {
      path: paths.ROUTE_PASSPORT_TRAINING_SETTING,
      component: pages.LazySafetyTrainingSettingPage
    },
    {
      path: paths.ROUTE_SYSTEM,
      component: pages.LazySystemPage
    }
  ],
  CONSTRUCTOR: [...commonDashboardRoutes, ...commonManagementRoutes],
  SUB_CONSTRUCTOR: [...commonDashboardRoutes, ...commonManagementRoutes]
};
